import React from "react";
import styled from "styled-components";
import {Button} from "./ButtonStyles";

const LoginButton = ({ isSubmitting }) => {
    return(
        <Btn className='btn-login' type="submit" disabled={isSubmitting}>
            <Title>
                Connexion
            </Title>
        </Btn>
    )
}

const Btn = styled(Button)`
  border: 2px solid white;
  background-color: transparent;
  align-self: center;
  width: 100%;
  max-width: 450px;
  height: 2.5rem;
  margin-top: 1.3rem;
  &:hover{
    background: var(--color-white);
    h5{
      color:  var(--color-purple);
    }
  }
  @media screen and (min-width: 900px) {
    width: 80%;
  }
  @media screen and (min-width: 1200px) {
    font-size: 16px;
  }
`
const Title = styled.h5`
  color: var(--color-white);
`
export default LoginButton;